export default {
  widgets: {
    cancelApplicationRequestApprovalPanel: {
      title: 'Заявка находится на рассмотрении',
      body: 'Пожалуйста, подождите окончания рассмотрения.',
    },
  },
};
